import React, { CFactory, Fragment, useContext, useEffect, useState } from "react";
import { useLocation } from 'wouter';
import { AuthContext } from "../contexts/auth";
import { getEmployeesWithActiveContract } from "../services/api_calendar";
import { exportEmployeeList } from '../services/api_extractions';
import { gruppaBustePerMese } from "../utils";
import { Link } from "wouter"
import { CheckCircleIcon, XCircleIcon, UsersIcon, ChevronUpIcon, ChevronDownIcon, NoSymbolIcon, InformationCircleIcon, PlusIcon } from "@heroicons/react/24/outline";
import moment from "moment";
import { DataContext } from "../contexts/data";
import { deleteDipendente } from "../services/api";
import Swal from "sweetalert2";
import Fetching from "./fetching";
import FilterModal from "./modal_filter_select";
import ComboboxAutocompleteAPI from "./combobox_autocomplete_api";
import ListBoxPageSize from "./listbox_pase_size";
import CustomDatePicker from "./custom_date_picker";
import ListBox from "./list_box";
import SystemUpdateAltOutlinedIcon from '@mui/icons-material/SystemUpdateAltOutlined';
import Footer from "../components/footer";
import CustomTooltipComponent from "../components/custom_tooltip_component";


export default function DipendentiTable(props) {
  const options = [
    { name: 'Data Inizio', value: 'start_date' },
    { name: 'Data Fine', value: 'end_date' },
  ];

  const { profile } = useContext(AuthContext)
  const { loading, token, company_id } = props
  const [dipendenti, setDipendenti] = useState([])
  const [fetching, setFetching] = useState(true)
  const [filter, setFilter] = useState('all');
  const [showModal, setShowModal] = useState(false);
  const [totalResult, setTotalResult] = useState(0);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(25);
  const [filterDate, setFilterDate] = useState(options[0]);
  const [showFilters, setShowFilters] = useState(true); 
  const [visibleColumns, setVisibleColumns] = useState({
    name: true,
    email_auth: true,
    start_date: true,
    end_date: true,
  });
  const [filterSelected, setFilterSelected] = useState('');

  const [sortConfig, setSortConfig] = useState({
    key: 'cf',
    direction: 'ascending',
  });

  const { dipendentiGlobal, setDipendentiGlobal } = useContext(DataContext)

  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [contractStartDate, setContractStartDate] = useState('');
  const [contractEndDate, setContractEndDate] = useState('');

  const hasConsultalaHRPro = profile && profile.level && profile.level.hasOwnProperty("consultala_hr_pro"); 


  const fetchEmployees = () => {
    const controller = new AbortController();
    const { signal } = controller;

    let filterBy = null;
    if (filter === 'active') filterBy = 'contract_active';
    else if (filter === 'inactive') filterBy = 'contract_not_active';
    else if (filter === 'app_activate') filterBy = 'app_active';
    else if (filter === 'hr_active') filterBy = 'hr_active';
    else if (filter === 'all') filterBy = 'all';


    setFetching(true);

    getEmployeesWithActiveContract(
      token,
      null,
      filterBy,
      signal,
      page,
      pageSize,
      null,
      'payrolls',
      contractStartDate,
      contractEndDate || null,
      sortConfig
    )
      .then((res) => {
        const employeesArray = Array.isArray(res.results) ? res.results : [];
        setDipendentiGlobal(employeesArray);
        setDipendenti(employeesArray);
        setTotalResult(res.count);
        setFetching(false);
      })
      .catch((err) => {
        if (err.name !== 'AbortError') {
          console.error(err);
          setFetching(false);
        }
      });

    return () => controller.abort();
  };

  useEffect(() => {
    if (token) fetchEmployees();
  }, [token, filter, page, pageSize, sortConfig, selectedEmployee]);

  const handlePageSizeChange = (newPageSize) => {
    setPageSize(newPageSize); 
    setPage(1); 
  };

  const handleNextPage = () => {
    if (page * pageSize < totalResult) {
      setPage(prevPage => prevPage + 1);
    }
  };

  const handlePreviousPage = () => {
    if (page > 1) {
      setPage(prevPage => prevPage - 1);
    }
  };

  useEffect(() => {
    setPage(1);
  }, [contractStartDate, contractEndDate]);

  const handleSelectFilters = () => {
    setShowModal(true);
    setFilterSelected(filter);
  };

  const handleExport = async ({ filters, format, contractStartDate, contractEndDate }) => {
    
    let filterBy = null;
    if (filter === 'active') filterBy = 'contract_active';
    else if (filter === 'inactive') filterBy = 'contract_not_active';
    else if (filter === 'app_activate') filterBy = 'app_active';
    else if (filter === 'hr_active') filterBy = 'hr_active';
    else filterBy = 'all';

    try {
      await exportEmployeeList(
        token,
        format,
        [filters],
        filterBy,
        contractStartDate,
        contractEndDate || null
      );
    } catch (error) {
      console.error('Error durante l\'esportazione:', error);
    }
  };

  const handleSelectEmployee = (selected) => {
    setSelectedEmployee(selected);
    setPage(1);
  };

  const handleResetEmployeeSelection = () => {
    setSelectedEmployee(null);
  };

  const handleCheckboxChange = (event) => {
    const newFilter = event.target.value;
  
    if (newFilter === filter) {
      return;
    }

    setFetching(true);
    setFilter(event.target.value);
    setSelectedEmployee(null);
  };

  const handleColumnVisibilityChange = (event) => {
    const { name, checked } = event.target;
    setVisibleColumns((prev) => ({ ...prev, [name]: checked }));
  };

  const handleSort = (key) => {
    setSortConfig((prev) => {
      if (prev.key === key) {
        return {
          key,
          direction: prev.direction === 'ascending' ? 'descending' : 'ascending',
        };
      } else {
        return { key, direction: 'ascending' };
      }
    });
  };
  
  const handleDelete = async (cf) => {
    const result = await Swal.fire({
      title: 'Sei sicuro?',
      html: `
        <p>Stai eliminando il dipendente <strong>${cf}</strong>, questa azione non può essere annullata!</p>
        <p>Digita <strong>\"ELIMINA\"</strong> per confermare</p>
      `,
      icon: 'warning',
      input: 'text',
      inputPlaceholder: 'Digita ELIMINA',
      inputValidator: (value) => {
        if (value !== 'ELIMINA') {
          return 'Digitare "ELIMINA" per procedere';
        }
        return null;
      },
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#64748b',
      confirmButtonText: 'Sì, elimina!',
      cancelButtonText: 'Annulla'
    });
  
    if (result.isConfirmed && result.value === 'ELIMINA') {
      try {
        await deleteDipendente(token, cf);
        setDipendenti(dipendenti.filter((dip) => dip.cf !== cf));
        Swal.fire('Eliminato!', 'Il dipendente è stato eliminato.', 'success');
        setSelectedEmployee(null);
      } catch (error) {
        console.error("Error deleting employee:", error);
        Swal.fire('Errore!', 'Si è verificato un errore durante l\'eliminazione del dipendente.', 'error');
      }
    }
  };
  
  if (fetching) {
    return <Fetching />
  }

  // SE NON SONO PRESENTI DIPENDENTI SUL FILTRO SELEZIONATO, APPARE RIQUADRO 'NON SONO PRESENTI DATI' MA COPRE I FILTRI. COMMENTATO PER ORA.
  // if (dipendenti.length == 0 && !fetching && filter !== 'app_activate') {
  //   return <div
  //     className="relative block w-full rounded-lg border-2 border-dashed border-gray-300 p-12 text-center hover:border-gray-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
  //   >
  //     {/*  */}
  //     <div role="status">
  //       <svg
  //         className="mx-auto h-12 w-12 text-gray-400"
  //         stroke="currentColor"
  //         fill="none"
  //         viewBox="0 0 48 48"
  //       >
  //         <path
  //           strokeLinecap="round"
  //           strokeLinejoin="round"
  //           strokeWidth={2}
  //           d="M8 14v20c0 4.418 7.163 8 16 8 1.381 0 2.721-.087 4-.252M8 14c0 4.418 7.163 8 16 8s16-3.582 16-8M8 14c0-4.418 7.163-8 16-8s16 3.582 16 8m0 0v14m0-4c0 4.418-7.163 8-16 8S8 28.418 8 24m32 10v6m0 0v6m0-6h6m-6 0h-6"
  //         />
  //       </svg>
  //     </div>
  //     <span className="mt-2 block text-sm font-semibold text-gray-900">Non risultano dipendenti creati</span>
  //   </div>
  // }

  function classNames(arg0, arg1) {
    throw new Error("Function not implemented.")
  }


  return (
    <>
      <div className="flex items-center">
        <Link to="/" className="border block rounded-md bg-grey-400 px-3 py-2 mr-2 text-center text-sm font-semibold text-grey-800 shadow-sm hover:bg-grey-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-grey-600">Torna indietro</Link>
        <Link
          to='/nuovo_dipendente'
          className={`inline-flex items-center gap-x-1.5 rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600`}
        >
          Aggiungi
          <PlusIcon className="-mr-0.5 h-5 w-5" />
        </Link>
        <div className="ml-auto">
          <button
            onClick={handleSelectFilters}
            className="inline-flex items-center gap-x-1.5 rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
          >
            <SystemUpdateAltOutlinedIcon style={{ height: '20px', width: '20px' }} />
            Esporta dati
          </button>
        </div>

      </div>

      <div className="flex items-center ">
        <div className="w-full flex flex-col sm:flex-row justify-between gap-4 pt-4 pb-4 px-3 sm:px-0">
          <div className="w-full sm:w-auto relative z-20">
            <ListBoxPageSize value={pageSize} onChange={handlePageSizeChange} />
          </div>

          <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-2 w-full sm:w-auto">
            <button
              className={`w-28 mt-2 sm:mt-0  me-4 inline-flex justify-center align-middle items-center rounded bg-indigo-600 h-6 text-xs font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 ${!selectedEmployee ? 'invisible' : ''}`}
              onClick={handleResetEmployeeSelection}
              disabled={!selectedEmployee}
            >
              Reset selezione
            </button>
            <div className="w-full sm:w-64 border border-gray-200 rounded-md shadow-md">
              <ComboboxAutocompleteAPI
                  getData={async (query) => {
                    if (query.trim() === '') {
                      return Promise.resolve([]);
                    }

                    const page = 1;
                    const pageSize = 10;

                    try {
                      const res = await getEmployeesWithActiveContract(token, query, 'all', null, page, pageSize);
                      const employeesArray = Array.isArray(res.results) ? res.results : [];
                      return employeesArray;
                    } catch (error) {
                      console.error("Errore durante il recupero dei dati:", error);
                      return [];
                    }
                  }}
                  getDisplay={(employee) => 
                    employee.last_name && employee.first_name 
                      ? `${employee.last_name} ${employee.first_name}` 
                      : employee.name || employee.cf || ''
                  }
                  getId={(employee) => employee.id}
                  onChange={handleSelectEmployee} 
                  currentValue={selectedEmployee || null}
                  placeholder="Digita per cercare il dipendente"
                />
            </div>
          </div>
        </div>
      </div>
      
      <div className="flex items-center">
        <table className="min-w-full min-h-full border-x border-b border-gray-200 rounded-lg">
          <thead className="sticky top-0 bg-white " style={{ zIndex: '10'}}>
            <tr 
              onClick={() => setShowFilters(prev => !prev)} 
              className="cursor-pointer bg-white z-20 hover:bg-indigo-100 transition text-left"
            >
              <th colSpan={7}>
                <div className="border-t border-gray-200 rounded-t-md bg-indigo-50 py-1">
                  <span className="text-sm uppercase font-bold text-indigo-700 pl-2">
                    {showFilters ? 'Nascondi filtri' : 'Mostra filtri'}
                  </span>
                </div>
              </th> 
            </tr>

            {showFilters && (
              <tr>
                <th colSpan={7} className="pb-3 bg-white z-20">
                    <div className="text-sm font-semibold text-gray-900 pb-4 pl-4 sm:pl-0 pt-4">
                      <div className="flex flex-col sm:grid sm:grid-cols-[auto_1fr] sm:gap-x-4 items-start text-left">
                        <span className="sm:pl-3 pb-2 sm:pb-0 w-48">Visualizza dipendenti:</span>
                        <div className="flex flex-wrap gap-x-6 gap-y-2">
                          <label className="flex items-center space-x-2">
                            <input
                              type="checkbox"
                              value="active"
                              checked={filter === 'active'}
                              onChange={handleCheckboxChange}
                              className="rounded border-gray-300 text-indigo-600 focus:ring-indigo-600"
                            />
                            <span>Contratti Attivi</span>
                          </label>

                          <label className="flex items-center space-x-2">
                            <input
                              type="checkbox"
                              value="inactive"
                              checked={filter === 'inactive'}
                              onChange={handleCheckboxChange}
                              className="rounded border-gray-300 text-indigo-600 focus:ring-indigo-600"
                            />
                            <span>Contratti Non Attivi</span>
                          </label>

                          <label className="flex items-center space-x-2">
                            <input
                              type="checkbox"
                              value="all"
                              checked={filter === 'all'}
                              onChange={handleCheckboxChange}
                              className="rounded border-gray-300 text-indigo-600 focus:ring-indigo-600"
                            />
                            <span>Tutti</span>
                          </label>

                          <label className="flex items-center space-x-2">
                            <input
                              type="checkbox"
                              value="app_activate"
                              checked={filter === 'app_activate'}
                              onChange={handleCheckboxChange}
                              className="rounded border-gray-300 text-indigo-600 focus:ring-indigo-600"
                            />
                            <span>Accesso App Abilitato</span>
                          </label>

                          <label className="flex items-center space-x-2">
                            <input
                              type="checkbox"
                              value="hr_active"
                              checked={filter === 'hr_active'}
                              onChange={handleCheckboxChange}
                              className="rounded border-gray-300 text-indigo-600 focus:ring-indigo-600"
                            />
                            <span>Accesso App e Contratto Attivo</span>
                          </label>
                        </div>
                      </div>
                    </div>

                    <div className="text-sm font-semibold text-gray-900 pb-4 pl-4 sm:pl-0 pt-4">
                      <div className="flex flex-col sm:grid sm:grid-cols-[auto_1fr] sm:gap-x-4 items-start text-left">
                        <span className="sm:pl-3 pb-2 sm:pb-0 w-48">Visualizza dettagli:</span>

                        <div className="flex flex-wrap gap-x-6 gap-y-2">
                          <label className="flex items-center space-x-2">
                            <input
                              type="checkbox"
                              name="name"
                              checked={visibleColumns.name}
                              onChange={handleColumnVisibilityChange}
                              className="rounded border-gray-300 text-indigo-600 focus:ring-indigo-600"
                            />
                            <span>Cognome e Nome</span>
                          </label>

                          <label className="flex items-center space-x-2">
                            <input
                              type="checkbox"
                              name="email_auth"
                              checked={visibleColumns.email_auth}
                              onChange={handleColumnVisibilityChange}
                              className="rounded border-gray-300 text-indigo-600 focus:ring-indigo-600"
                            />
                            <span>Email</span>
                          </label>

                          <label className="flex items-center space-x-2">
                            <input
                              type="checkbox"
                              name="start_date"
                              checked={visibleColumns.start_date}
                              onChange={handleColumnVisibilityChange}
                              className="rounded border-gray-300 text-indigo-600 focus:ring-indigo-600"
                            />
                            <span>Data Inizio</span>
                          </label>

                          <label className="flex items-center space-x-2">
                            <input
                              type="checkbox"
                              name="end_date"
                              checked={visibleColumns.end_date}
                              onChange={handleColumnVisibilityChange}
                              className="rounded border-gray-300 text-indigo-600 focus:ring-indigo-600"
                            />
                            <span>Data Fine</span>
                          </label>
                        </div>
                      </div>
                    </div>
                
              
                    <div className="text-sm font-semibold text-gray-900 pb-4 pl-4 sm:pl-0 pt-4">
                      <div className="flex flex-col sm:grid sm:grid-cols-[auto_1fr] sm:gap-x-4 items-start text-left">
                        <span className="sm:pl-3 pb-2 sm:pb-0 w-48">Filtra per data contratto</span>
                        <div className="flex flex-wrap gap-x-6 gap-y-2">
                          <div className="flex flex-col sm:flex-row items-start sm:items-center gap-2 w-full sm:w-auto">
                            <label htmlFor="date_from" className="text-sm font-medium text-gray-700 w-28 text-left sm:pe-3">Data Inizio</label>
                            <input
                              type="date"
                              id="date_from"
                              name="date_from"
                              value={contractStartDate}
                              onChange={(e) => setContractStartDate(e.target.value)}
                              className="border border-gray-300 shadow-sm rounded-md px-2 py-1 text-sm w-full sm:w-36"
                            />
                          </div>

                          <div className="flex flex-col sm:flex-row items-start sm:items-center gap-2 w-full sm:w-auto">
                            <label htmlFor="date_to" className="text-sm font-medium text-gray-700 w-28 text-left sm:pe-3">Data Fine</label>
                            <input
                              type="date"
                              id="date_to"
                              name="date_to"
                              value={contractEndDate}
                              onChange={(e) => setContractEndDate(e.target.value)}
                              className="border border-gray-300 shadow-sm rounded-md px-2 py-1 text-sm w-full sm:w-36"
                            />
                          </div>
                    
                          <button 
                            className="inline-flex items-center gap-x-1.5 rounded-md bg-indigo-600 px-3 py-1 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                            onClick={(e) => {
                              e.preventDefault();

                              if (contractEndDate && !contractStartDate) {
                                Swal.fire({
                                  icon: 'warning',
                                  title: 'Data Inizio richiesta',
                                  text: 'Per usare la data di fine, devi inserire anche una data di inizio contratto.',
                                  confirmButtonText: 'OK'
                                });
                                return;
                              }
                              fetchEmployees();
                            }}
                          >
                            Cerca
                          </button>
                        </div>
                      </div>
                    </div>
                </th>
              </tr>
            )}
            <tr className="bg-gray-50">
              {visibleColumns.name && (
                <th
                  scope="col"
                  colSpan={1}
                  className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900 hidden lg:table-cell whitespace-normal"
                  style={{ width: '20%' }}
                >
                  Cognome e Nome
                </th>
              )}
              <th
                scope="col"
                colSpan={1}
                className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                style={{ width: '15%' }}
              >
                <div className="flex items-center">
                  Codice Fiscale
                  <button
                    onClick={() => handleSort('cf')}
                    className="ml-2 text-gray-500 hover:text-gray-900"
                  >
                    {sortConfig.key === 'cf' && sortConfig.direction === 'ascending' ? (
                      <CustomTooltipComponent title="Decrescente" placement="bottom" arrow>
                        <ChevronUpIcon className="w-4 h-4" />
                      </CustomTooltipComponent>
                    ) : (
                      <CustomTooltipComponent title="Crescente" placement="bottom" arrow>
                        <ChevronDownIcon className="w-4 h-4" />
                      </CustomTooltipComponent>
                    )}
                  </button>
                </div>
              </th>
              {visibleColumns.email_auth && (
                <th
                  scope="col"
                  colSpan={1}
                  className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900 hidden lg:table-cell"
                  style={{ width: '15%' }}
                >
                  Email
                </th>
              )}
              {visibleColumns.start_date && (
                <th
                  scope="col"
                  colSpan={1}
                  className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900 hidden lg:table-cell whitespace-normal"
                  style={{ width: '10%' }}
                >
                  <div className="flex items-center">
                    Data Inizio
                    <button
                      onClick={() => handleSort('start_date')}
                      className="ml-2 text-gray-500 hover:text-gray-900"
                    >
                      {sortConfig.key === 'start_date' && sortConfig.direction === 'ascending' ? (
                        <CustomTooltipComponent title="Decrescente" placement="bottom" arrow>
                          <ChevronUpIcon className="w-4 h-4" />
                        </CustomTooltipComponent>
                      ) : (
                        <CustomTooltipComponent title="Crescente" placement="bottom" arrow>
                          <ChevronDownIcon className="w-4 h-4" />
                        </CustomTooltipComponent>
                      )}
                    </button>
                  </div>
                </th>
              )}
              {visibleColumns.end_date && (
                <th
                  scope="col"
                  colSpan={1}
                  className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900 hidden lg:table-cell whitespace-normal"
                  style={{ width: '10%' }}
                >
                  <div className="flex items-center">
                    Data Fine
                    <button
                      onClick={() => handleSort('end_date')}
                      className="ml-2 text-gray-500 hover:text-gray-900"
                    >
                      {sortConfig.key === 'end_date' && sortConfig.direction === 'ascending' ? (
                        <ChevronUpIcon className="w-4 h-4" />
                      ) : (
                        <ChevronDownIcon className="w-4 h-4" />
                      )}
                    </button>
                  </div>
                </th>
              )}
              <th
                scope="col"
                colSpan={1}
                className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900 cursor-pointer"
                style={{ width: '10%' }}
                onClick={() => {
                  Swal.fire({
                    title: 'Requisiti per il Login',
                    html: `
                      <p>
                        Il dipendente, per poter effettuare il login, ha necessità dei seguenti requisiti:
                      </p><br/>
                      <p>
                        L'app deve essere attiva.<br/><br/>
                        Il contratto deve essere attivo oppure cessato da non più di 18 mesi.
                      </p><br/>
                      <p>
                        L'attivazione dell'app e l'aggiunta di un contratto possono essere gestite nella scheda di dettaglio del dipendente.
                      </p>
                    `,
                    icon: 'info',
                    confirmButtonText: 'OK',
                  });
                }}
              >
                Stato Login
                <InformationCircleIcon className="inline-flex w-5 h-5 ml-1 align-center text-cyan-500" />
              </th>
              <th
                scope="col"
                colSpan={1}
                className="px-3 py-3.5 text-right text-sm font-semibold text-gray-900"
                style={{ width: '10%' }}
              >
              </th>
            </tr>
          </thead>
          <tbody className="bg-white">
            {(selectedEmployee ? 
              [selectedEmployee] : dipendenti
            ).map((dip) => (
              <React.Fragment key={dip?.id || dip?.cf || 'selected-employee'}>
                <tr className="border-gray-200 border-t">
                  {visibleColumns.name && (
                    <td className="whitespace-normal px-3 py-4 text-sm text-gray-500 hidden lg:table-cell" style={{ width: '20%' }}>
                      {`${dip?.last_name ?? ''} ${dip?.first_name ?? ''}`}
                    </td>
                  )}
                  <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500" style={{ width: '15%' }}>
                    {dip?.cf}
                  </td>
                  {visibleColumns.email_auth && (
                    <td className="whitespace-normal px-3 py-4 text-sm text-gray-500 hidden lg:table-cell" style={{ width: '15%', wordBreak: 'break-word' }}>
                      {dip?.email_auth}
                    </td>
                  )}
                  {visibleColumns.start_date && (
                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500 hidden lg:table-cell" style={{ width: '10%' }}>
                      {dip?.active_contract 
                        ? (dip?.active_contract?.start_date ? moment(dip?.active_contract.start_date).format('DD/MM/YYYY') : '')
                        : (dip?.last_contract?.start_date ? moment(dip.last_contract.start_date).format('DD/MM/YYYY') : '')
                      }
                    </td>
                  )}
                  {visibleColumns.end_date && (
                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500 hidden lg:table-cell" style={{ width: '10%' }}>
                      {dip?.active_contract 
                        ? (dip?.active_contract?.end_date ? moment(dip?.active_contract.end_date).format('DD/MM/YYYY') : '')
                        : (dip?.last_contract?.end_date ? moment(dip?.last_contract.end_date).format('DD/MM/YYYY') : '')
                      }
                    </td>
                  )}
              
                  <td
                    className="relative whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-3"
                    style={{ width: '10%' }}
                  >
                    <div className="flex flex-col items-start space-y-2">
                      <div className="group relative flex items-center justify-center">
                        {(() => {
                          let canAccess = false;
                          let contractCanAccess = false;
                          let contractType = '';

                          let appActivate = dip?.app_activate === true || dip?.app_activate === 'true';

                          if (dip?.active_contract) {
                            contractCanAccess = true;
                            contractType = 'attivo';
                          } else if (dip?.last_contract?.end_date) {
                            const endDate = new Date(dip.last_contract.end_date);
                            const today = new Date();
                            const diffMonths =
                              (today.getFullYear() - endDate.getFullYear()) * 12 +
                              (today.getMonth() - endDate.getMonth());

                            if (diffMonths <= 18) {
                              contractCanAccess = true;
                              contractType = 'cessato negli ultimi 18 mesi';
                            }
                          }

                          if (appActivate && contractCanAccess) {
                            canAccess = true;
                          }

                          return canAccess ? (
                            <>
                              <CheckCircleIcon className="h-5 w-5 text-green-500 opacity-100 group-hover:opacity-50 transition-opacity" />
                              <button
                                onClick={() => {
                                  Swal.fire({
                                    title: 'Dettaglio Accesso',
                                    html: `
                                      <p>Contratto attivo o cessato negli ultimi 18 mesi: <br/><strong>${contractType}</strong></p><br/>
                                      <p>Accesso App Abilitato: <br/><strong>Sì</strong></p>
                                    `,
                                    icon: 'info',
                                    confirmButtonText: 'OK',
                                  });
                                }}
                                className="absolute flex items-center justify-center px-4 py-2 text-center text-sm text-gray-500 bg-green-50 hidden group-hover:flex text-gray-700 text-wrap cursor-pointer"
                              >
                                Può accedere all'app
                              </button>
                            </>
                          ) : (
                            <>
                              <NoSymbolIcon className="h-5 w-5 text-red-500 opacity-100 group-hover:opacity-50 transition-opacity" />
                              <button
                                onClick={() => {
                                  Swal.fire({
                                    title: 'Dettaglio Accesso',
                                    html: `
                                      <p>Contratto attivo o cessato negli ultimi 18 mesi: <br/><strong>${contractType || 'Nessuno'}</strong></p><br/>
                                      <p>Accesso App Abilitato: <br/><strong>${appActivate ? 'Sì' : 'No'}</strong></p>
                                    `,
                                    icon: 'info',
                                    confirmButtonText: 'OK',
                                  });
                                }}
                                className="absolute flex items-center justify-center px-4 py-2 text-center text-sm text-gray-500 bg-red-50 hidden group-hover:flex  text-gray-700 text-wrap cursor-pointer z-10"
                              >
                                Non può accedere all'app
                              </button>
                            </>
                          );
                        })()}
                      </div>
                    </div>
                  </td>
                  <td
                    className="relative whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-3"
                    style={{ width: '10%' }}
                  >
                    <div className="flex flex-col items-start space-y-2" style={{ position: 'relative', zIndex: '0' }}>
                      <Link
                        to={`/dipendenti/${dip?.cf}`}
                        className="inline-flex items-center justify-center rounded-full bg-white px-2.5 py-1 text-xs font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 w-20 text-center"
                      >
                        Apri
                      </Link>
                      <Link
                        to={`/dipendenti/${dip?.cf}/edit`}
                        className="inline-flex items-center justify-center rounded-full bg-white px-2.5 py-1 text-xs font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 w-20 text-center"
                      >
                        Modifica
                      </Link>
                      <button
                        onClick={() => handleDelete(dip?.cf)}
                        className="inline-flex items-center justify-center rounded-full bg-white px-2.5 py-1 text-xs font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-red-500 hover:text-white w-20 text-center"
                      >
                        Elimina
                      </button>
                    </div>
                  </td>
                </tr>
              </React.Fragment>
            ))}

            {!selectedEmployee && dipendenti.length === 0 && (
              <tr>
                <td colSpan={7} className="m-8 rounded-lg border-2 border-dashed border-gray-300 p-6 text-center hover:border-gray-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 text-sm font-semibold text-gray-900">
                  <div className="text-center py-4">Non sono presenti dati</div>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      
      <div>
        {!selectedEmployee ? (
          <div className="flex justify-between my-8 px-8">
            {totalResult > pageSize && (
              <>
                <button 
                  className="inline-flex items-center rounded-md bg-white px-2.5 py-1.5 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
                  onClick={handlePreviousPage}
                  disabled={page === 1}
                >
                  Precedente
                </button>
                <span className='text-sm font-medium text-gray-900'>Pagina {page} di {Math.ceil(totalResult / pageSize)}</span>
                <button 
                  className="inline-flex items-center rounded-md bg-white px-2.5 py-1.5 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
                  onClick={handleNextPage} 
                  disabled={page * pageSize >= totalResult}
                >
                  Successivo
                </button>
              </>
            )}
          </div>
        ) : ('')}
      </div>
      <div className="pt-8 stycky bottom-0">
        <Footer />
      </div>
      {showModal && (
        <FilterModal
          onClose={() => setShowModal(false)}
          onApply={handleExport}
          filtersSelected={filterSelected}
          startDate={contractStartDate}
          endDate={contractEndDate}
        />
      )}
    </>
  )}